<template>

    <CRow>
        <CCol col="12" lg="10">
            <CCard>
                <CCardHeader>
                    <strong>{{ dish.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <CNav variant="tabs">
                        <CNavItem :to="`/restaurants/${restaurant.id}/dishes/${dish.id}`">
                            Карточка
                        </CNavItem>
                        <CNavItem
                            v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)" 
                            :to="`/restaurants/${restaurant.id}/dishes/${dish.id}/edit`">
                            Редактировать
                        </CNavItem>
                        <CNavItem :to="`/restaurants/${restaurant.id}/dishes/${dish.id}/ingredient-groups`">
                            Группы ингредиентов
                        </CNavItem>
                        <CNavItem active>
                            Группы модификаторов
                        </CNavItem>
                    </CNav>
                    <CRow class="pl-3 pb-3" />
                    <div class="flex flex-row-reverse">
                        <CButton
                            v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)" 
                            color="primary"
                            class="mt-2"
                            @click="create"
                        >Создать</CButton
                        >
                    </div>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <table class="table">
                            <thead>
                                <th></th>
                                <th>Название</th>
                                <th>Модификаторы</th>
                                <th>Активен</th>
                            </thead>
                            <tr>
                                <td></td>
                                <td>
                                    <CLink
                                        v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)"
                                        :to="`/restaurants/${restaurant.id}/dishes/${dish.id}/modifiers`"
                                    >На выбор</CLink>
                                    <div v-else>
                                        На выбор
                                    </div>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <draggable
                                v-model="modifierGroups"
                                tag="tbody"
                                handle=".handle">
                                <tr v-for="group in modifierGroups" :key="group.id">
                                    <td>
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle"
                                        />
                                    </td>
                                    <td>
                                        <CLink
                                            v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)"
                                            :to="`/restaurants/${restaurant.id}/dishes/${dish.id}/modifier-groups/${group.id}`"
                                        >{{ group.title }}</CLink>
                                        <div v-else>
                                            {{ group.title }}
                                        </div>
                                    </td>
                                    <td>{{ getGroupModifiers(group) }}</td>
                                    <td>
                                        <CBadge :color="getBadge(group.enabled)">
                                            &nbsp;{{ group.enabled ? 'Да' : 'Нет' }}&nbsp;
                                        </CBadge>
                                    </td>
                                    <td v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)" >
                                        <CButton @click="removeGroup(group.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)" >
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="info"
                        class="mr-3"
                        @click="save"
                    >Сохранить расположение</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    export default {
        name: 'ModifierGroups',

        components: {
            draggable,
        },

        icons: {
            cilCursorMove,
            cilTrash
        },
  
        data () {
            return {
                restaurant: {},
                dish: {},
                modifierGroups: [],
            }
        },
    
        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        },
  
        mounted() {
            const id = parseInt(this.$route.params.id);
            const dish_id = parseInt(this.$route.params.dish_id);
            Vue.axios.get('/restaurants/' + id)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get('/restaurants/' + id + '/dishes/' + dish_id)
                .then(resp => {
                    this.dish = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get(`/restaurants/${id}/dishes/modifier-groups/${dish_id}`)
                .then(resp => {
                    this.modifierGroups = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            getGroupModifiers(group) {
                const groupModifiers = group.modifiers.reduce((title, modifier, ind) => {
                    title += `${modifier.title}${ind === (group.modifiers.length - 1) ? '' : ', '}`;
                    return title;
                }, '');

                return groupModifiers.length < 50 ? groupModifiers : `${groupModifiers.slice(0, 50)}...`;
            },
            goBack() {
                this.$router.push({ path: '/restaurants/' + this.restaurant.id + '/dishes' })
            },
            create () {
                this.$router.push(
                    `/restaurants/${this.restaurant.id}/dishes/${this.dish.id}/modifier-groups/create`
                );
            },
            save () {
                // Save order only
                const reorder = [];
                let index = 0;
                this.modifierGroups.forEach(group => {
                    reorder.push({
                        id: group.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post(`/restaurants/${this.restaurant.id}/dishes/modifier-groups/reorder/${this.dish.id}`, { reorder })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            removeGroup (id) {
                this.modifierGroups = this.modifierGroups.filter(group => group.id !== id);
                Vue.axios
                    .delete(`/restaurants/${this.restaurant.id}/dishes/modifier-groups/${id}`)
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
